export default {
  testList(state) {
    return state.testList;
  },
};
